import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as authActions from 'redux/modules/auth';
import { translate } from 'react-i18next';

@translate(['common'])
@connect(
  state => ({ user: state.auth.user }),
  authActions)
export default
  class LoginSuccess extends Component {

  render() {
    const { user, logout, t } = this.props;
    return (user &&
      <div className="container">
        <h1>{t("loginSuccess.login_success")}</h1>

        <div>
          <p>{t("loginSuccess.you_are_logged", {name:user.name})}
          </p>

          <div>
            <button className="btn btn-danger" onClick={logout}><i className="fa fa-sign-out" />{' '}{t("main.deconnexion")}</button>
          </div>
        </div>
      </div>
    );
  }
}
